import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoSelectModule } from '@go-modules/directives/go-select/go-select.module';
import { NgxGroupService } from '@go-modules/services/group/group.service';
import { TranslateModule } from '@ngx-translate/core';
import { ActivityFactory, activityToken } from 'go-modules/models/activity/activity.factory';
import { map, Observable, shareReplay } from 'rxjs';
import type { ActivityModel } from 'go-modules/models/activity/activity.schema';
import type { Group } from '@go-modules/interfaces/groups/group.interface';
import { UserService, userServiceToken } from 'go-modules/models/user/user.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';

@Component({
	selector: 'ngx-session-activity-selector',
	templateUrl: './session-activity-selector.component.html',
	styleUrls: ['./session-activity-selector.component.scss'],
	imports: [
		TranslateModule,
		AsyncPipe,
		FormsModule,
		ReactiveFormsModule,
		GoSelectModule,
		MatTooltipModule,
		MatSelectModule
	],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NgxSessionActivitySelectorComponent implements OnInit {
	@Input() public labelText: string;
	@Input() public group: Group;
	@Input() public activity: ActivityModel;
	@Input() public disabled: boolean;

	@Output() public onChange: EventEmitter<ActivityModel> = new EventEmitter();

	public activities$: Observable<ActivityModel[]>;

	constructor (
		private ngxGroupService: NgxGroupService,
		@Inject(activityToken) private Activity: ActivityFactory,
		@Inject(userServiceToken) public userService: UserService
	) {}

	public ngOnInit (): void {
		this.activities$ = this.ngxGroupService.getActivities({
			folder_id: this.group.group_id,
			availability_date: null,
			due_date: null
		}).pipe(
			shareReplay(1),
			map((activities) => {
				return activities.sort((a, b) =>
					a.sort_index - b.sort_index).map((activity) => this.Activity.model(activity));
			})
		);
	}

	public disabledOption (activity: any) {
		if (this.userService.currentUser.is_root_user) {
			return false;
		}

		if (activity.has_single_recording_attempt) {
			return true;
		}

		return activity.activity_template_id !== this.activity.activity_template_id &&
			!this.activity.isDefault();
	}

	public handleChange (activity: any): void {
		this.onChange.emit(this.Activity.model(activity));
	}
}
